import { useQuery } from "react-query";
import { useEffect, useState } from "react";
import { getBindAccountList } from "@/pages/profile/helper/getBindAccountList";
import { useGlobalStore } from "@/store/GlobalStore";
import { ThirdParty } from "project-config/constants/third-party";
import {
  BindMiniProgramIcon,
  BindQqIcon,
  BindWechatIcon,
} from "@/pages/profile/components/bind-account-icon";
import { getUserCenterRedirectDomain } from "project-config/utils/domain";
// import { getWechatThirdPartyAppId } from "project-config/utils/third-party";
import {
  JUMP_LINKS,
  UNBIND_DIALOG_TITLE,
  UNBIND_DIALOG_MESSAGE,
} from "@/pages/profile/constant/mini-program";
import { useTranslation } from "react-i18next";
// import { host as taskHost } from "project-config/utils/env";

interface BindAccountData {
  fromWhere: ThirdParty;
  id?: string;
  nickname?: string;
  headimgurl?: string;
  [k: string]: any;
}

export function useBindAccount() {
  const { isSubAccount } = useGlobalStore();
  const [bindList, setBindList] = useState<BindAccountData[]>([]);
  const [miniProgramBindList, setMiniProgramBindList] = useState<
    BindAccountData[]
  >([]);
  const [openMiniProgramBind, setOpenMiniProgramBind] = useState(false);

  const { data } = useQuery<BindAccountData[]>(
    "/api/rendering/user/wxbind/getBindWx"
  );
  useEffect(() => {
    if (!data) return;

    const bindAccountList = getBindAccountList(data);
    const miniProgramBindAccountList = data.filter(
      (item) => item.fromWhere === ThirdParty.MiniProgram
    );
    !isSubAccount && setBindList(bindAccountList);
    setMiniProgramBindList(miniProgramBindAccountList);
  }, [data, isSubAccount]);

  const { userInfo } = useGlobalStore();
  const bindAccount = (type: ThirdParty) => {
    const host = getUserCenterRedirectDomain();
    // if (type === ThirdParty.WeChat) {
    //   window.location.href = `https://open.weixin.qq.com/connect/qrconnect?appid=${getWechatThirdPartyAppId()}&response_type=code&scope=snsapi_login&redirect_uri=${encodeURIComponent(
    //     `${taskHost}/sso/oauth-callback?type=wechat`
    //   )}`;
    //   return;
    // }
    window.location.href = `${window.location.protocol}//${host}${JUMP_LINKS[type]}&phone=${userInfo?.phone}`;
  };

  const { t } = useTranslation("profile");
  const [openUnbindModal, setOpenUnbindModal] = useState(false);
  const [unbindAccount, setUnbindAccount] = useState<BindAccountData>();
  const [unbindModalTitle, setUnbindModalTitle] = useState<string>();
  const [unbindModalContent, setUnbindModalContent] = useState<string>();
  const [openBindMiniModal, setOpenBindMiniModal] = useState(false);
  useEffect(() => {
    if (typeof unbindAccount === "undefined") {
      setUnbindModalTitle(undefined);
      setUnbindModalContent(undefined);
      return;
    }

    const title = t(UNBIND_DIALOG_TITLE[unbindAccount.fromWhere]);
    const content = t(UNBIND_DIALOG_MESSAGE[unbindAccount.fromWhere]);
    setUnbindModalTitle(title);
    setUnbindModalContent(content);
  }, [unbindAccount, t]);

  const bindAccountMeta = useBindAccountMeta();
  return {
    bindList,
    bindAccount,
    openUnbindModal,
    setOpenUnbindModal,
    unbindAccount,
    setUnbindAccount,
    unbindModalTitle,
    unbindModalContent,
    bindAccountMeta,
    openBindMiniModal,
    setOpenBindMiniModal,
    miniProgramBindList,
    openMiniProgramBind,
    setOpenMiniProgramBind,
  };
}

export const useBindAccountMeta = () => {
  const { t } = useTranslation("profile");
  return {
    [ThirdParty.QQ]: {
      icon: BindQqIcon,
      name: t("QQ"),
    },
    [ThirdParty.WeChat]: {
      icon: BindWechatIcon,
      name: t("wechat_account"),
    },
    [ThirdParty.MiniProgram]: {
      icon: BindMiniProgramIcon,
      name: t("applet"),
    },
  };
};
